import Send from './Send';

export default Send;
